<template>
  <div>
    <BootstrapDialog
      title="查看跟踪进度"
      ref="dialog"
      size="lg"
      @afterClose="afterClose()"
    >
      <template v-slot:body>
        <div class="panel-body">
          <div class="row">
            <div style="width: 100%;padding:10px">
              <table width="100%" class="table xunw_table_form" border="0">
                <tbody>
                  <tr>
                    <td
                      width="15%"
                      align="center"
                      colspan="2"
                      style="background-color: #A4D3EE;"
                      class="bg-info"
                    >
                      <h4 class="panel-title">
                        <i class="fa fa-book"></i> 个人信息
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <th width="15%" align="right">姓名：</th>
                    <td width="35%">{{ model.xm }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">身份证号：</th>
                    <td width="35%">{{ model.sfzh }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">手机号：</th>
                    <td width="35%">{{ model.sjh }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">生日：</th>
                    <td width="35%">{{ model.csrq }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">学历：</th>
                    <td width="35%">{{ model.xl | xlFilters }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">性别：</th>
                    <td width="35%">{{ model.xb | xbFilters }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">民族：</th>
                    <td width="35%">{{ model.mz }}</td>
                  </tr>


                  <tr>
                    <td
                      width="15%"
                      align="center"
                      colspan="2"
                      style="background-color: #A4D3EE;"
                      class="bg-info"
                    >
                      <h4 class="panel-title">
                        <i class="fa fa-book"></i> 报考信息
                      </h4>
                    </td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">注册批次：</th>
                    <td width="35%">{{ model.zcpcmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">注册点：</th>
                    <td width="35%">{{ model.zcdmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">招生点：</th>
                    <td width="35%">{{ model.zsdmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">主考学校：</th>
                    <td width="35%">{{ model.zkxxmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">助学机构：</th>
                    <td width="35%">{{ model.zxjgmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">班级：</th>
                    <td width="35%">{{ model.bjmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">班主任：</th>
                    <td width="35%">{{ model.bzrmc }}</td>
                  </tr>

                  <tr>
                    <th width="15%" align="right">意向客户来源：</th>
                    <td width="35%">{{ model.source | sourceFilters }}</td>
                  </tr>

                  <tr>
                     <th width="15%" align="right">准考证号：</th>
                    <td width="35%">{{ model.zkzh }}</td>

                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="panel-heading" style="background-color: #A4D3EE;">
                <h4 class="panel-title"><i class="fa fa-book"></i>记录图片</h4>
              </div>

              <div class="imgList">
                <ul>
                  <li v-for="(item, i) in jlDataArr" :key="i" >
                    <div>
                      <div v-for="(img, m) in item.lxnr" :key="m" style="text-align:center">
                        <img
                          :src="img"
                          alt=""
                          class="weChat"
                          v-if="isNotNULL(img)"
                          preview="1"
                        />
                      </div>
                      <div style="text-align:center">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="del(item.id)"
                        >
                          删除
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          style="margin-left:10px"
          class="btn btn-default"
          type="button"
          @click="close()"
        >
          关闭
        </button>
      </template>
    </BootstrapDialog>
  </div>
</template>
<script>
export default {
  name: "StudentUserListSeeMsg",
  components: {},
  data: function() {
    return {
      imgArr: [],
      model: {},
      mzList: [
        { text: "汉族", value: "HAN" },
        { text: "蒙古族", value: "MONGOL" },
        { text: "回族", value: "HUI" },
        { text: "藏族", value: "TIBETAN" },
        { text: "维吾尔族", value: "UYGHUR" },
        { text: "苗族", value: "MIAO" },
        { text: "彝族", value: "YI" },
        { text: "壮族", value: "ZHUANG" },
        { text: "布依族", value: "BUYEI" },
        { text: "朝鲜族", value: "KOREAN" },
        { text: "满族", value: "MANCHU" },
        { text: "侗族", value: "DONG" },
        { text: "瑶族", value: "YAO" },
        { text: "白族", value: "BAI" },
        { text: "土家族", value: "TUJIA" },
        { text: "哈尼族", value: "HANI" },
        { text: "哈萨克族", value: "KAZAK" },
        { text: "傣族", value: "DAI" },
        { text: "黎族", value: "LI" },
        { text: "傈僳族", value: "LISU" },
        { text: "佤族", value: "VA" },
        { text: "畲族", value: "SHE" },
        { text: "高山族", value: "GAOSHAN" },
        { text: "拉祜族", value: "LAHU" },
        { text: "水族", value: "SUI" },
        { text: "东乡族", value: "DONGXIANG" },
        { text: "纳西族", value: "NAXI" },
        { text: "景颇族", value: "JINGPO" },
        { text: "柯尔克孜族", value: "KIRGIZ" },
        { text: "土族", value: "TU" },
        { text: "达斡尔族", value: "DAUR" },
        { text: "仫佬族", value: "MULAO" },
        { text: "羌族", value: "QIANG" },
        { text: "布朗族", value: "BLANG" },
        { text: "撒拉族", value: "SALAR" },
        { text: "毛南族", value: "MAONAN" },
        { text: "仡佬族", value: "GELAO" },
        { text: "锡伯族", value: "XIBE" },
        { text: "阿昌族", value: "ACHANG" },
        { text: "普米族", value: "PUMI" },
        { text: "塔吉克族", value: "TAJIK" },
        { text: "怒族", value: "NU" },
        { text: "乌孜别克族", value: "UZBEK" },
        { text: "俄罗斯族", value: "RUSSIANS" },
        { text: "鄂温克族", value: "EWENKI" },
        { text: "德昂族", value: "DEANG" },
        { text: "保安族", value: "BONAN" },
        { text: "裕固族", value: "YUGUR" },
        { text: "京族", value: "GIN" },
        { text: "塔塔尔族", value: "TATAR" },
        { text: "独龙族", value: "DERUNG" },
        { text: "鄂伦春族", value: "OROQEN" },
        { text: "赫哲族", value: "HEZHEN" },
        { text: "门巴族", value: "MONBA" },
        { text: "珞巴族", value: "LHOBA" },
        { text: "基诺族", value: "JINO" },
        { text: "其他", value: "OTHER" },
        { text: "外国血统中国籍人士", value: "FOREIGN_COUNTRY" },
      ],
      zcid: null, //记录id
      jlDataArr: [],
    };
  },
  created() {},
  filters: {
    // 来源
    sourceFilters(value) {
      if (value == "INDEPENDENT") {
        return "独立开发";
      } else if (value == "BUILD_COLLEGE_HAlf") {
        return "建立院校(半服)";
      } else if (value == "BUILD_COLLEGE_ALL") {
        return "建立院校(全服务)";
      } else if (value == "PHONE_VISIT") {
        return "电话来访";
      } else if (value == "WECHAT_CONSULT") {
        return "微信咨询";
      } else if (value == "CHANNEL_INTRODUCE") {
        return "渠道介绍";
      } else if (value == "STUDENT_INTRODUCE") {
        return "学生介绍";
      } else if (value == "SCHOOL_REGISTRATION") {
        return "网校注册";
      } else if (value == "CUSTOMER_INTRODUCE") {
        return "客户介绍";
      } else if (value == "QQ") {
        return "QQ咨询";
      } else if (value == "BIG_DATA") {
        return "大数据";
      } else if (value == "ONLINE_RETAILER") {
        return "电商";
      }
    },

    // 学历
    xlFilters(value) {
      if (value == "XIAOXUE") {
        return "小学";
      } else if (value == "CHUZHONG") {
        return "初中";
      } else if (value == "GAOZHONG") {
        return "高中";
      } else if (value == "JIXIAO") {
        return "技校";
      } else if (value == "GAOJI") {
        return "高技";
      } else if (value == "ZHIGAO") {
        return "职高";
      } else if (value == "DAZHUNAN") {
        return "大专";
      } else if (value == "DAXUE") {
        return "大学";
      } else if (value == "BENKE") {
        return "本科";
      } else if (value == "SHUOSHI") {
        return "硕士";
      } else if (value == "BOSHI") {
        return "博士";
      } else if (value == "ZHONGZHUNAN") {
        return "中专";
      } else if (value == "QITA") {
        return "其他";
      }
    },
    // 性别
    xbFilters(value) {
      if (value == "F") {
        return "女";
      } else if (value == "M") {
        return "男";
      }
    },
  },
  methods: {
    isNotNULL: function(item) {
      return item != undefined && item != null && item.length > 0;
    },
    del(jlId) {
      this.$http
        .post("/htgl/biz/trackRecord/delete", { id: jlId })
        .then((res) => {
          if (res.data == true) {
            this.$success("操作成功", () => {
              this.loading(this.model.zcId);
            });
          }
        });
    },

    // 招生点
    reset: function() {
      this.model = {};
    },
    open(row) {
      this.model = row;
      this.model.zcId = row.zcid;
      this.mzList.forEach((item) => {
        if (row.mz == item.value) {
          this.model.mz = item.text;
        }
      });

      this.loading(row.zcid);
      this.$previewRefresh();

      this.$refs.dialog.open();
    },
    loading(zcid) {
      this.$http.post(`/htgl/biz/trackRecord/${zcid}`).then((res) => {
        res.data.forEach((item, i) => {
          item.lxnr = item.lxnr.split(",");
        });
        this.jlDataArr = res.data;
      });
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },
  },
};
</script>
<style scoped>
.weChat {
  margin-top: 10px;
  width: 70%;
  height: 150px;
  background: no-repeat;
  margin: 10px 0;
  border-radius: 5%;
}
li {
  list-style: none;
}
.imgList {
  margin-top: 10px;
  background-color: #f5f5f5;
  border-radius: 2%;
  margin: 5px;
}
</style>
